class NovieexProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainTrigger = this.querySelector('[data-gallery-main-trigger]');
    this.mainImage = this.querySelector('.novieex-product-hero__main-image');
    this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
    this.mainPreviousButton = this.querySelector('[data-gallery-main-previous]');
    this.mainNextButton = this.querySelector('[data-gallery-main-next]');

    this.mainTrigger?.addEventListener('click', () => {
      if (!(this.dialog instanceof HTMLDialogElement) || this.images.length === 0) return;
      this.open(Number(this.mainTrigger.dataset.galleryIndex), this.mainTrigger);
    });
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.selectMain(Number(thumbnail.dataset.galleryIndex), thumbnail));
    });
    this.mainPreviousButton?.addEventListener('click', () => this.selectAdjacentMain(-1));
    this.mainNextButton?.addEventListener('click', () => this.selectAdjacentMain(1));

    this.dialog = this.querySelector('[data-gallery-dialog]');
    this.images = Array.from(this.querySelectorAll('.novieex-product-gallery-dialog__image'));
    this.counter = this.querySelector('[data-gallery-counter]');
    this.previousButton = this.querySelector('[data-gallery-previous]');
    this.nextButton = this.querySelector('[data-gallery-next]');

    if (!(this.dialog instanceof HTMLDialogElement) || this.images.length === 0) return;

    this.querySelector('[data-gallery-close]')?.addEventListener('click', () => this.dialog.close());
    this.previousButton?.addEventListener('click', () => this.select(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.select(this.activeIndex + 1));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.select(this.activeIndex - 1);
      if (event.key === 'ArrowRight') this.select(this.activeIndex + 1);
    });
    this.dialog.addEventListener('close', () => this.trigger?.focus());
  }

  open(index, trigger) {
    this.trigger = trigger;
    this.select(index);
    this.dialog.showModal();
  }

  selectMain(index, thumbnail) {
    if (!(this.mainImage instanceof HTMLImageElement) || !this.mainTrigger) return;

    const src = thumbnail.dataset.galleryFullSrc;
    if (!src) return;

    this.mainImage.src = src;
    this.mainImage.removeAttribute('srcset');
    this.mainImage.alt = thumbnail.dataset.galleryAlt || '';
    this.mainTrigger.dataset.galleryIndex = String(index);
    this.mainTrigger.setAttribute('aria-label', `Open ${this.mainImage.alt} in full screen`);
    this.thumbnails.forEach((item) => item.removeAttribute('aria-current'));
    thumbnail.setAttribute('aria-current', 'true');
  }

  selectAdjacentMain(direction) {
    if (this.thumbnails.length === 0) return;

    const currentIndex = Number(this.mainTrigger?.dataset.galleryIndex || 0);
    const nextIndex = (currentIndex + direction + this.thumbnails.length) % this.thumbnails.length;
    this.selectMain(nextIndex, this.thumbnails[nextIndex]);
  }

  select(index) {
    const count = this.images.length;
    this.activeIndex = (index + count) % count;

    this.images.forEach((image, imageIndex) => {
      image.hidden = imageIndex !== this.activeIndex;
    });

    if (this.counter) this.counter.textContent = `${this.activeIndex + 1} / ${count}`;
    const hasMultipleImages = count > 1;
    if (this.previousButton) this.previousButton.hidden = !hasMultipleImages;
    if (this.nextButton) this.nextButton.hidden = !hasMultipleImages;
  }
}

if (!customElements.get('novieex-product-gallery')) {
  customElements.define('novieex-product-gallery', NovieexProductGallery);
}
